module.exports = __webpack_public_path__ + "media/images/payment/logo_ae-8cfb78bf26f37c80ce149272b3cde86d.gif";